import {
  Button,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Select,
  Textarea,
} from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col } from 'styled-bootstrap-grid'
import commonUtils from '@/utils/commonUtils'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface TermsDetailItem {
  cmpnyCd: string
  termsId: string
  termsVer: string
  termsTit: string
  termsCont: string
  termsGubn: string
  useYn: string
  effectiveDate: string
  regId: string
  regDate: string
  updId: string
  updDate: string
}

const detailTermsMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showAlert, showConfirm } = useDialog()
  const [requestData] = useState({
    termsId: location.state?.termsId || '',
    termsVer: location.state?.termsVer || '',
  })

  const [terms, setTerms] = useState<TermsDetailItem>({
    cmpnyCd: '',
    termsId: '',
    termsVer: '',
    termsTit: '',
    termsCont: '',
    termsGubn: '01', // 01 : 필수, 02 : 선택
    useYn: 'Y', // Y , N
    effectiveDate: '',
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
  })

  const getTermsDetail = async () => {
    try {
      const response = await axios.post('/termsMgmt/detail', {
        termsId: requestData.termsId,
        termsVer: requestData.termsVer,
      })
      // TODO 성공 실패 관련해서 실패코드가 업무별로 있는게 ..
      const termsData = response.data.data.terms
      if (termsData) {
        setTerms(termsData)
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setTerms((prevState) => {
      //if (!prevState) return null

      return {
        ...prevState,
        [name]: value,
      } as TermsDetailItem // 모든 필드를 포함하는 상태를 유지
    })
  }

  const validate = () => {
    // TODO 타입 체크는 어떻게 해야할까 > 약관코드&버전은 숫자형 문자열인뎁
    const validateInfo: any = {
      cmpnyCd: {
        type: 'n',
        require: false,
        name: '회사코드',
      },
      termsId: {
        type: 'n',
        require: true,
        name: '약관코드',
      },
      termsVer: {
        type: 'n',
        require: true,
        name: '약관버전',
      },
      termsTit: {
        type: 's',
        require: true,
        name: '약관제목',
      },
      termsCont: {
        type: 's',
        require: true,
        name: '약관내용',
      },
      termsGubn: {
        type: 's',
        require: true,
        name: '약관구분',
      },
      useYn: {
        type: 's',
        require: true,
        name: '사용여부',
      },
      effectiveDate: {
        type: 's',
        require: false,
        name: '시행일시',
      },
    }
    let validateResult = true
    Object.entries(terms).forEach(([key, value]) => {
      if (validateResult && validateInfo[key]) {
        // 알림창 1회만 노출되도록
        if (validateInfo[key].require && (!value || value.trim() === '')) {
          // 필수값인경우
          const name = validateInfo[key].name || ''
          const code = name.charCodeAt(name.length - 1)
          if (code < 0xac00 || code > 0xd7a3 || (code - 0xac00) % 28 === 0) {
            showAlert({
              type: 'warning',
              title: name + '를 입력해주세요',
            })
          } else {
            showAlert({
              type: 'warning',
              title: name + '을 입력해주세요',
            })
          }
          validateResult = false
        }
      }
    })

    return validateResult
  }

  const updateTerms = async () => {
    if (!validate()) {
      return
    }
    try {
      const response: any = await axios.post(
        !requestData.termsId ? '/termsMgmt/insert' : '/termsMgmt/update',
        terms,
      )
      if (response.data.common.resultCode == 'TERMS0202') {
        // TODO 약관등록(수정) 성공 코드 -> 공통 성공코드로 변경해야할듯?
        navigate('/termsMgmt', {state : {termsTit : location.state?.termsTit || '', page : location.state?.page || 1, perPage: location.state?.perPage || 10}})
                  
      } else {
        showAlert({
          title: response.data.common.resultMsg || '약관 저장을 실패했어요.',
        })
      }
    } catch (error) {
      showAlert({
        title: '약관 저장을 실패했어요.',
      })
      console.error('Error fetching terms reg:', error)
    }
  }

  useEffect(() => {
    if (!!requestData.termsId) {
      // 파라미터로 전달된 약관ID값이 있으면 수정, 없으면 등록
      getTermsDetail()
    }
  }, [])
  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>약관등록/수정</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>
                showConfirm({
                  title: '약관관리 화면으로 이동할까요?',
                  onConfirm() {
                    navigate('/termsMgmt', {state : {termsTit : location.state?.termsTit || '', page : location.state?.page || 1, perPage: location.state?.perPage || 10}})
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
            <Button
              onClick={() =>
                showConfirm({
                  title: '약관정보를 저장할까요?',
                  onConfirm() {
                    updateTerms()
                  },
                })
              }
              color="neverbe"
            >
              저장
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <Container>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="termsId">
                약관코드
              </Label>
              <Input
                id="termsId"
                name="termsId"
                type="text"
                // placeholder="약관코드는 자동 생성됩니다."
                maxLength={10}
                value={terms.termsId}
                disabled={!!requestData.termsId}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="termsVer">
                약관버전
              </Label>
              <Input
                id="termsVer"
                name="termsVer"
                type="text"
                placeholder=""
                maxLength={3}
                value={terms.termsVer}
                disabled={!!requestData.termsId}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="termsGubn">
                약관구분
              </Label>
              <Select
                id="termsGubn"
                name="termsGubn"
                value={terms.termsGubn}
                onChange={handleInputChange}
                // TODO 공통코드에서 가져오기?
              >
                <option value={'01'}>필수</option>
                <option value={'02'}>선택</option>
                {/* {bizGubn.map((item) => (
                            <option key={item.code} value={item.code}>
                                {item.name}
                            </option>
                            ))} */}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="termsTit">
                약관제목
              </Label>
              <Input
                id="termsTit"
                name="termsTit"
                type="text"
                placeholder="약관제목을 입력해주세요."
                maxLength={250}
                value={terms.termsTit}
                disabled={false}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="termsCont">
                약관내용
              </Label>
              <Textarea
                id="termsCont"
                name="termsCont"
                placeholder="약관내용을 입력해주세요."
                value={terms.termsCont}
                disabled={false}
                height={'200px'}
                // TODO reesize 필요한가?
                // resize={"none"}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <Select
                id="useYn"
                name="useYn"
                value={terms.useYn}
                onChange={handleInputChange}
                // TODO 공통코드에서 가져오기?
              >
                <option value={'Y'}>Y</option>
                <option value={'N'}>N</option>
                {/* {bizGubn.map((item) => (
                            <option key={item.code} value={item.code}>
                                {item.name}
                            </option>
                            ))} */}
              </Select>
            </FormGroup>
          </Col>
          {
            !!requestData.termsId ? 
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="effectiveDate">
                  시행일시
                </Label>
                <Input
                  id="effectiveDate"
                  name="effectiveDate"
                  type="text"
                  placeholder=""
                  maxLength={100}
                  value={terms.effectiveDate}
                  disabled={true}
                  // onChange={handleInputChange}
                />
              </FormGroup>
            </Col>: <Col col></Col>
          }
          <Col col></Col>
        </Row>
        {
          !!requestData.termsId ? <>
          <Row>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="regId">
                  등록자
                </Label>
                <Input
                  id="regId"
                  name="regId"
                  type="text"
                  placeholder=""
                  maxLength={100}
                  value={terms.regId}
                  disabled={true}
                  // onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="regDate">
                  등록일시
                </Label>
                <Input
                  id="regDate"
                  name="regDate"
                  type="text"
                  placeholder=""
                  maxLength={100}
                  value={commonUtils.formatDate(terms.regDate, true)}
                  disabled={true}
                  // onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="updId">
                  수정자
                </Label>
                <Input
                  id="updId"
                  name="updId"
                  type="text"
                  placeholder=""
                  maxLength={100}
                  value={terms.updId}
                  disabled={true}
                  // onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
            <Col col>
              <FormGroup mb="20px">
                <Label display="block" mb="5px" htmlFor="updDate">
                  수정일시
                </Label>
                <Input
                  id="updDate"
                  name="updDate"
                  type="text"
                  placeholder=""
                  maxLength={100}
                  value={commonUtils.formatDate(terms.updDate, true)}
                  disabled={true}
                  // onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
          </Row></> :<></>
        }
      </Container>
      {/* <Modal
        show={modalInfo.show}
        onClose={() => setModalInfo({ ...modalInfo, show: false })}
        size="sm"
      >
        <ModalBody>{modalInfo.message}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setModalInfo({ ...modalInfo, show: false })
              modalInfo.confirmAction()
            }}
          >
            {modalInfo.confirmBtn}
          </Button>
          <Button
            color="secondary"
            onClick={() => setModalInfo({ ...modalInfo, show: false })}
          >
            닫기
          </Button>
        </ModalFooter>
      </Modal> */}
    </>
  )
}
export default detailTermsMgmt
